export const gitVersion = {
  "tag": "v6.1.7-4",
  "commit": "b135539d5843f638b300a67daec4fe253e6781cb",
  "branch": "hotfix/605-bankid-double-collect-v4"
}